/* globals $, rscpCfg */
/* eslint-disable camelcase, new-cap */
var calcContentFrameSize;

function Integration () {
    this.CONTENT_FRAME_NAME = "ScormContent";

    // constants local to this specific integration
    this.MENU_INDENT = 20;

    this.NumDeliverableScos = null;
}
Integration.prototype = {
    /* eslint-disable no-use-before-define */
    PostResourceStringsLoaded: Integration_PostResourceStringsLoaded,
    PostRunTimeCreation: Integration_PostRunTimeCreation,
    GetMenuItemElementTag: Integration_GetMenuItemElementTag,
    PopulateMenuItemElement: Integration_PopulateMenuItemElement,
    UpdateIndentLevel: Integration_UpdateIndentLevel,
    GetDocumentObjectForMenu: Integration_GetDocumentObjectForMenu,
    GetDocumentObjectForControls: Integration_GetDocumentObjectForControls,
    GetHtmlElementToInsertMenuWithin: Integration_GetHtmlElementToInsertMenuWithin,
    UpdateMenuStateDisplay: Integration_UpdateMenuStateDisplay,
    SetMenuToggleVisibility: Integration_SetMenuToggleVisibility,
    ShowMenu: Integration_ShowMenu,
    HideMenu: Integration_HideMenu,
    ShowExitDialog: Integration_ShowExitDialog,
    HideExitDialog: Integration_HideExitDialog,
    UpdateControlState: Integration_UpdateControlState,
    UpdateProgressBar: Integration_UpdateProgressBar,
    GetString: Integration_GetString,
    PreOverallSequencingProcess: Integration_PreOverallSequencingProcess,
    PostScoLoaded: Integration_PostScoLoaded,
    PostScoUnloaded: Integration_PostScoUnloaded,

    // function for this integration to override the look and feel of the left menu
    // comment out when not overriding
    OverrideMenuLookAndFeel: Integration_OverrideMenuLookAndFeel,

    UpdateLocalizedStrings: function () {
        //
        // this method needs to be callable multiple times
        //
        $("#rscp-logo").attr("title", this.GetString("Logo"));
        $("#CourseMenuTitle").html(this.GetString("Course Menu"));
        $("#previous-text").html(this.GetString("Previous"));
        $("#next-text").html(this.GetString("Next"));
        $("#close-text").html(this.GetString("Close Item"));
        $("#exit-text").html(this.GetString("Return to LMS"));
        $("#exit_dialog_suspend").html(this.GetString("Suspend All"));
        $("#exit_dialog_exit").html(this.GetString("Exit All"));
        $("#viewDebug-text").html(this.GetString("View Debug"));
        $("#returnToLmsNoDebug-text").html(this.GetString("Exit Without Saving Debug"));

        $("#previous").attr("title", this.GetString("Previous"));
        $("#next").attr("title", this.GetString("Next"));
        $("#closeSco").attr("title", this.GetString("Close Item"));
        $("#returnToLms").attr("title", this.GetString("Return to LMS"));
        $("#viewDebug").attr("title", this.GetString("View Debug"));
        $("#returnToLmsNoDebug").attr("title", this.GetString("Exit Without Saving Debug"));

        $("#MenuPlaceHolderDiv").attr("aria-label", this.GetString("Course Menu"));
        $("#title").attr("aria-label", this.GetString("Course Title:") + document.title);
        $("#menu-container").attr("aria-label", this.GetString("Player Controls"));
        $("#previous").attr("aria-label", this.GetString("Load Previous Content Item"));
        $("#next").attr("aria-label", this.GetString("Load Next Content Item"));
        $("#closeSco").attr("aria-label", this.GetString("Close Current Content Item"));
        $("#ContentDiv").attr("aria-label", this.GetString("Learning Content"));

        $("#rscp-privacyPolicy-link").html(this.GetString("Privacy Policy"));

        // eslint-disable-next-line newline-per-chained-call
        $("#ContentDiv").find("iframe").attr("title", this.GetString("Please make a selection."));
    }
};

(function () {
    var header = null,
        privacyPolicy = null,
        menu = null,
        frame = null,
        zeroHeightRetries = 0;

    calcContentFrameSize = function () {
        var docWidth = $(document).width(),

            // determining window height is suspect at best, particularly
            // when factoring in combinations of jquery and iOS, at least
            // one customer via dispatch was getting a zero height (so
            // content not visible) so try to mitigate that problem
            winHeight = $(window).height() || window.innerHeight,
            calcHeight = winHeight,
            menuHeight;

        if (header === null) {
            header = $("#rscp-header");
            privacyPolicy = $("#rscp-privacyPolicy");
            menu = $("#rscp-sidebar");
            frame = $("#ContentDiv").find("iframe");
        }

        if (header.length !== 0 && header.css("display") !== "none") {
            calcHeight -= header.outerHeight();
        }
        if (privacyPolicy.length !== 0 && privacyPolicy.css("display") !== "none") {
            calcHeight -= privacyPolicy.outerHeight();
        }

        // if width greater than the pixel value that Bootstrap considers "small"
        // then the menu will move to the left of the content frame so...
        //
        // determine if our calculated height is less than the menu and if so
        // use the menu height as the frame height
        if (docWidth > 991 && menu.css("display") !== "none") {
            // 10 is the margin on the menu
            menuHeight = menu.height() + 10;
            if (calcHeight < menuHeight) {
                calcHeight = menuHeight;
            }
        }

        // having 0 content frame height at the end of this routine is generally
        // just bad, so do whatever we can to get to a valid value, force some
        // non-zero default and force an attempt to recalculate it to get a
        // proper value in case it is merely a timing issue, so long as there
        // haven't already been some arbitrary number of attempts suspecting
        // that after X unsuccessful attempts that it just won't be successful
        if (calcHeight <= 0) {
            calcHeight = 320;

            if (zeroHeightRetries < 10) {
                zeroHeightRetries += 1;

                window.setTimeout(calcContentFrameSize, 100);
            }
        }

        if (window.innerHeight > 0 && calcHeight > window.innerHeight) {
            calcHeight = window.innerHeight;
        }

        frame.css("height", calcHeight);

        window.setTimeout(
            function () {
                $(window).one("resize", calcContentFrameSize);
            },
            500
        );
    };
}());

function GetControlWindow () {
    var controlWindow = window,
        control = controlWindow.Control,
        depth = 0,
        maxDepth = 10;

    if (! this.controlWindow) {
        while (! (control || depth > maxDepth)) {
            controlWindow = window.parent;
            control = controlWindow.Control;
            depth += 1;
        }
        this.controlWindow = controlWindow;
    }

    return this.controlWindow;
}

function _exitElementHandler (event) {
    var btn,
        control;

    if (event.type === "keydown") {
        if (event.keyCode !== 13 && event.keyCode !== 32) {
            return;
        }
    }

    control = GetControlWindow().Control;

    //
    // if this event started with a button explicitly turning off the recording
    // of debug logs, then force that off, otherwise use the original configuration
    // setting to set it in the control object, doing this allows a user to click
    // the button in 2004 which often uses a dialog button and then for them to click
    // the other option which triggers the same dialog but should have the opposite
    // behavior
    //
    if (event.currentTarget.id.indexOf("NoDebug") > -1) {
        control.ShouldSaveClientDebugLogs = false;
    }
    else {
        control.ShouldSaveClientDebugLogs = rscpCfg.get("shouldSaveClientDebugLogs");
    }

    // Control.TriggerReturnToLMS might either actually return to the LMS
    // or in SCORM 2004 4th edition (or certain other courses based on
    // package properties) it might mark "shouldToggle" true
    // in which case we allow the exit mode dropdown to open instead
    btn = $("#returnToLms").get(0);
    btn.shouldToggle = false;

    control.TriggerReturnToLMS();

    if (btn.shouldToggle) {
        // allow default dropdown toggle behavior to occur
        return true;
    }

    event.stopPropagation();
}

// eslint-disable-next-line complexity
function Integration_PostResourceStringsLoaded () {
    /* globals MergeQueryStringParameters */
    var topParams = rscpCfg.get("topParams"),
        intermediatePage = rscpCfg.get("intermediatePage"),
        logo = rscpCfg.get("modernLogo"),
        privacyPolicyUrl = rscpCfg.get("privacyPolicyUrl"),
        body = $("body"),
        frameName = this.CONTENT_FRAME_NAME,
        frame = $("#ContentDiv").find("iframe");

    document.title = typeof topParams.courseTitle !== "undefined" ? topParams.courseTitle : rscpCfg.get("registrationToDeliver").Package.LearningObjects[0].Title;

    this.UpdateLocalizedStrings();

    if (typeof topParams.showNavBar !== "undefined" && topParams.showNavBar) {
        body.removeClass("hideNavBar");
    }
    if (typeof topParams.showProgress !== "undefined" && topParams.showProgress) {
        body.removeClass("hideProgress");
    }
    if (typeof topParams.showTitleBar !== "undefined" && topParams.showTitleBar) {
        body.removeClass("hideTitleBar");
    }
    if (typeof topParams.enableFlow !== "undefined" && topParams.enableFlow) {
        body.removeClass("disableFlow");
    }
    if (typeof topParams.showClose !== "undefined" && topParams.showClose) {
        body.removeClass("hideClose");
    }
    if (typeof topParams.showFinish !== "undefined" && topParams.showFinish) {
        body.removeClass("hideFinish");
    }
    if (typeof topParams.showCourseStructure !== "undefined" && topParams.showCourseStructure) {
        $("#rscp-sidebar").addClass("sr-only");

        body.removeClass("hideCourseStructure");

        $("#toggleMenu").on(
            "click",
            function () {
                GetControlWindow().Control.ToggleMenuVisibility();
                calcContentFrameSize();
            }
        );
    }
    if (rscpCfg.get("shouldSaveClientDebugLogs")) {
        body.removeClass("hideDebug").addClass("showDebug");

        $("#viewDebug").on(
            "click",
            function () {
                GetControlWindow().Debug.ShowAllAvailableData();
            }
        );
        $("#returnToLmsNoDebug").on(
            "click keydown",
            _exitElementHandler
        );
    }
    if (logo !== "") {
        $("#rscp-logo").attr("src", logo);

        body.removeClass("hideLogo");
    }
    if (privacyPolicyUrl !== "") {
        $("#rscp-privacyPolicy-link").attr("href", privacyPolicyUrl);

        body.removeClass("hidePrivacyPolicy");
    }

    frame.attr("id", frameName)
        .attr("name", frameName);

    if (rscpCfg.get("intermediatePageLoadAtStart")) {
        frame.attr("src", MergeQueryStringParameters(intermediatePage.PageHref, intermediatePage.Parameters) + "&SignalLoaded=false");
    }

    frame[0].contentWindow.name = frameName;

    $("html").attr("lang", topParams.cc);

    $("#courseTitleText").text(document.title);

    if (typeof topParams.preventRightClick !== "undefined" && topParams.preventRightClick) {
        window.document.oncontextmenu = function () {
            return false;
        };
    }

    calcContentFrameSize();
}

function Integration_PostRunTimeCreation () {
    /* globals DebugCommandSentry */
    DebugCommandSentry.addTargetElement();
}

//
// Return an object of this type from each of the functions that interacts with the menu items.
// This will store the current state of the display.
// The next time the menu item is updated, this display will be passed back.
// You should compare the current state with the desired state before making any changes to the DOM.
// This will result in much more efficient code since manipulating the DOM is an expensive operation.
// The properties that you include here are up to you and your display. The SCP simply stores and forwards this object.
//

function DisplayState () {
    this.SuccessImageClass = "";
    this.CompletionImageClass = "";
    this.ActiveDisplayed = null;
    this.EnabledDisplayed = null;
    this.StatusTitleDisplayed = null;
    this.MenuTitleDisplayed = null;
}

function Integration_GetString (key) {
    /* globals AppStrings */
    var value = AppStrings[key],
        str,
        args,
        i,
        regExToReplace;

    if (typeof value !== "undefined" && value !== null && value.length > 0) {
        str = value;
    }
    else {
        // If the key doesn't have a value defined for it, use the key itself as the value.  We don't
        // want to create an error situation here so the worse case is an english string is shown instead
        // of a localized string.
        str = key;
    }

    // using built-in arguments but should probably do somethign better in the future
    args = Array.prototype.slice.call(arguments);
    // Substitute variables if this is a formatted string with {0}, {1}, etc
    for (i = 1; i < args.length; i += 1) {
        regExToReplace = new RegExp("\\{" + (i - 1) + "\\}", "g");
        if (args[i] === null) {
            args[i] = "";
        }

        str = str.replace(regExToReplace, args[i].toString());
    }

    return str;
}

function Integration_GetMenuItemElementTag () {
    return "li";
}

// activityIdentifier is a combination of item id and database id that can be used for identifiying HTML elements
// (just activity id alone is not enough because html elements names aren't case sensitive)
// activityItemId is the item identifier that needs to be passed to the choice request
function Integration_PopulateMenuItemElement (
    rootElement,
    documentObject,
    activityIdentifier,
    activityTitle,
    indentLevel,
    deliverable,
    learningStandard,
    statusDisplay,
    activityItemId,
    activity,
    menuItem
) {
    var totalIndent,
        completionImage,
        successImage,
        link,
        currentDisplayState,
        direction = rscpCfg.get("langDirection");

    //
    // Changing the DOM structure, class names, element ids, etc. of this menu may require
    // corresponding updates in scormformance autotest
    //
    // DOM was specifically designed for accessibility purposes, making any significant changes
    // should include testing in a screenreader such as VoiceOver (Mac)
    //

    totalIndent = indentLevel * this.MENU_INDENT;

    completionImage = documentObject.createElement("span");
    completionImage.id = "CompletionStatusImg" + activityIdentifier;
    completionImage.className = "sidebar-completion-unknown";
    completionImage.setAttribute("role", "presentation");

    successImage = documentObject.createElement("span");
    successImage.id = "SuccessStatusImg" + activityIdentifier;
    successImage.className = "sidebar-success-unknown";
    successImage.setAttribute("role", "presentation");

    link = documentObject.createElement("a");
    link.id = "MenuItemText" + activityIdentifier;
    link.className = "menulink";
    link.text = activityTitle;
    link.setAttribute("role", "presentation");

    if (direction === "rtl") {
        link.style.paddingRight = totalIndent + "px";
    }
    else {
        link.style.paddingLeft = totalIndent + "px";
    }

    if (statusDisplay === STATUS_DISPLAY_COMPLETION_ONLY || statusDisplay === STATUS_DISPLAY_SEPERATE || statusDisplay === STATUS_DISPLAY_COMBINED) {
        rootElement.appendChild(completionImage);
    }
    if (statusDisplay === STATUS_DISPLAY_SUCCESS_ONLY || statusDisplay === STATUS_DISPLAY_SEPERATE) {
        rootElement.appendChild(successImage);
    }
    rootElement.appendChild(link);
    rootElement.className = "menuitem";
    rootElement.title = activityTitle;

    // aria-level doesn't seem to support 0 index levels
    rootElement.setAttribute("aria-level", indentLevel + 1);
    if (deliverable) {
        rootElement.setAttribute("role", "link");
    }
    else {
        rootElement.setAttribute("role", "heading");
    }

    if (menuItem.Enabled) {
        // in this function we always need the menuItem to become enabled if it is marked enabled,
        // so forceably set it to not enabled, then in .Enable it will be switched back, this prevents
        // us from having to copy the things .Enable does here or pulling them out into yet another function
        menuItem.Enabled = false;
        menuItem.Enable(activityItemId, activityTitle);
    }

    currentDisplayState = new DisplayState();

    currentDisplayState.SuccessImageClass = "sidebar-success-unknown";
    currentDisplayState.CompletionImageClass = "sidebar-completion-unknown";
    currentDisplayState.ActiveDisplayed = null;
    currentDisplayState.EnabledDisplayed = null;
    currentDisplayState.StatusTitleDisplayed = "";
    currentDisplayState.MenuTitleDisplayed = "";

    return currentDisplayState;
}

function Integration_UpdateIndentLevel (rootElement, activityIdentifier, indentLevel) {
    var totalIndent = indentLevel * this.MENU_INDENT,
        link = rootElement.getElementsByTagName("a")[0],
        direction = rscpCfg.get("langDirection");

    // we don't want to let it set the indent below 0
    if (totalIndent < 0) {
        totalIndent = 0;
    }

    if (direction === "rtl") {
        link.style.paddingRight = totalIndent + "px";
    }
    else {
        link.style.paddingLeft = totalIndent + "px";
    }
    rootElement.setAttribute("aria-level", indentLevel + 1);
}

// gets called from the window containing the controller
function Integration_GetDocumentObjectForMenu () {
    return window.document;
}

// private to this specific integration
function Integration_GetDocumentObjectForControls () {
    return window.document;
}

// gets called from the window containing the controller
function Integration_GetHtmlElementToInsertMenuWithin () {
    return $("#MenuPlaceHolderDiv")[0];
}

// function called when a menu item's status has changed and needs to be graphically updated
// eslint-disable-next-line complexity
function Integration_UpdateMenuStateDisplay (
    rootElement,
    documentObject,
    activity,
    activityIdentifier,
    deliverable,
    currentActivity,
    navigationRequestInfo,
    learningStandard,
    statusDisplay,
    currentDisplayState,
    useLookAheadActivityStatus
) {
    /* globals
       RESULT_UNKNOWN,
       STATUS_DISPLAY_SEPERATE,
       STATUS_DISPLAY_SUCCESS_ONLY,
       STATUS_DISPLAY_COMPLETION_ONLY,
       STATUS_DISPLAY_COMBINED
    */
    /* eslint-disable no-lonely-if */
    var newDisplayState = new DisplayState(),
        activityIsCompleted,
        activityIsSatisfied,
        statusTitle = "",
        completionTitle = "",
        successTitle = "",
        activityIsActive = currentActivity !== null && typeof currentActivity !== "undefined" && activity.GetItemIdentifier() === currentActivity.GetItemIdentifier(),
        completionImage = null,
        successImage = null,
        menuText,
        menuItem;

    newDisplayState.ActiveDisplayed = null;
    newDisplayState.EnabledDisplayed = null;
    newDisplayState.TitleDisplayed = "";

    if (activity.WasAutoCompleted === true && activity.LookAheadActivity === true && useLookAheadActivityStatus === true) {
        activityIsCompleted = RESULT_UNKNOWN;
    }
    else {
        activityIsCompleted = activity.IsCompleted();
    }

    if (activity.WasAutoSatisfied === true && activity.LookAheadActivity === true && useLookAheadActivityStatus === true) {
        activityIsSatisfied = RESULT_UNKNOWN;
    }
    else {
        activityIsSatisfied = activity.IsSatisfied();
    }

    if (statusDisplay === STATUS_DISPLAY_SEPERATE) {
        // dual status display
        if (activityIsCompleted === true) {
            newDisplayState.CompletionImageClass = "sidebar-completion-completed";
            completionTitle = this.GetString("Completed");
        }
        else if (activityIsCompleted === false) {
            newDisplayState.CompletionImageClass = "sidebar-completion-incomplete";
            completionTitle = this.GetString("Requirement Not Fulfilled");
        }
        else {
            newDisplayState.CompletionImageClass = "sidebar-completion-unknown";
            completionTitle = this.GetString("Not Started");
        }

        statusTitle = completionTitle + " / ";

        if (activityIsSatisfied === true) {
            newDisplayState.SuccessImageClass = "sidebar-success-passed";
            successTitle += this.GetString("Passed");
        }
        else if (activityIsSatisfied === false) {
            newDisplayState.SuccessImageClass = "sidebar-success-failed";
            successTitle += this.GetString("Requirement Not Fulfilled");
        }
        else {
            newDisplayState.SuccessImageClass = "sidebar-success-unknown";
            successTitle += this.GetString("Unknown");
        }

        statusTitle += successTitle;
    }
    else if (statusDisplay === STATUS_DISPLAY_COMPLETION_ONLY || statusDisplay === STATUS_DISPLAY_COMBINED) {
        // single status display
        if (activityIsCompleted === true) {
            newDisplayState.CompletionImageClass = "sidebar-completion-completed";
            statusTitle = this.GetString("Completed");
        }
        else if (activityIsCompleted === false) {
            newDisplayState.CompletionImageClass = "sidebar-completion-incomplete";
            statusTitle = this.GetString("Requirement Not Fulfilled");
        }
        else {
            newDisplayState.CompletionImageClass = "sidebar-completion-unknown";
            statusTitle = this.GetString("Not Started");
        }
        if (statusDisplay === STATUS_DISPLAY_COMBINED) {
            // success status overrides complete status
            if (activityIsSatisfied === true) {
                statusTitle = this.GetString("Passed");
            }
            else if (activityIsSatisfied === false) {
                statusTitle = this.GetString("Requirement Not Fulfilled");
            }
        }
    }
    else if (statusDisplay === STATUS_DISPLAY_SUCCESS_ONLY) {
        if (activityIsSatisfied === true) {
            statusTitle += this.GetString("Passed");
        }
        else if (activityIsSatisfied === false) {
            statusTitle += this.GetString("Requirement Not Fulfilled");
        }
        else {
            statusTitle += this.GetString("Unknown");
        }
    }

    if (navigationRequestInfo.WillSucceed === true) {
        newDisplayState.EnabledDisplayed = true;
    }
    else {
        newDisplayState.EnabledDisplayed = false;
    }

    if (activityIsActive) {
        newDisplayState.ActiveDisplayed = true;
    }
    else {
        newDisplayState.ActiveDisplayed = false;
    }

    if (learningStandard.is2004()) {
        if (activity.GetPrimaryObjective().GetMeasureStatus(null, false)) {
            statusTitle += " / ";
            statusTitle += this.GetString("Score: {0}", activity.GetPrimaryObjective().GetNormalizedMeasure(null, false));
            successTitle += " / ";
            successTitle += this.GetString("Score: {0}", activity.GetPrimaryObjective().GetNormalizedMeasure(null, false));
        }
    }
    else {
        if (activity.RunTime !== null) {
            if (activity.RunTime.ScoreRaw !== null) {
                statusTitle += " / ";
                successTitle += " / ";

                if (activity.RunTime.ScoreMax !== null) {
                    statusTitle += this.GetString("Score: {0} of {1}", activity.RunTime.ScoreRaw, activity.RunTime.ScoreMax);
                    successTitle += this.GetString("Score: {0} of {1}", activity.RunTime.ScoreRaw, activity.RunTime.ScoreMax);
                }
                else {
                    statusTitle += this.GetString("Score: {0}", activity.RunTime.ScoreRaw);
                    successTitle += this.GetString("Score: {0}", activity.RunTime.ScoreRaw);
                }
            }
        }
    }

    newDisplayState.StatusTitleDisplayed = statusTitle;
    newDisplayState.MenuTitleDisplayed = statusTitle;

    if (statusDisplay === STATUS_DISPLAY_SEPERATE || statusDisplay === STATUS_DISPLAY_COMBINED || statusDisplay === STATUS_DISPLAY_COMPLETION_ONLY) {
        if (newDisplayState.CompletionImageClass !== currentDisplayState.CompletionImageClass) {
            completionImage = documentObject.getElementById("CompletionStatusImg" + activityIdentifier);
            completionImage.className = newDisplayState.CompletionImageClass;
        }
    }

    if (statusDisplay === STATUS_DISPLAY_SEPERATE || statusDisplay === STATUS_DISPLAY_SUCCESS_ONLY) {
        if (newDisplayState.SuccessImageClass !== currentDisplayState.SuccessImageClass) {
            successImage = documentObject.getElementById("SuccessStatusImg" + activityIdentifier);
            successImage.className = newDisplayState.SuccessImageClass;
        }
    }

    if ((newDisplayState.EnabledDisplayed !== currentDisplayState.EnabledDisplayed)
        || (newDisplayState.ActiveDisplayed !== currentDisplayState.ActiveDisplayed)
        || (newDisplayState.MenuTitleDisplayed !== currentDisplayState.MenuTitleDisplayed)) {
        menuText = documentObject.getElementById("MenuItemText" + activityIdentifier);

        if (newDisplayState.ActiveDisplayed === true) {
            if (
                (newDisplayState.ActiveDisplayed !== currentDisplayState.ActiveDisplayed)
                || (newDisplayState.EnabledDisplayed !== currentDisplayState.EnabledDisplayed)
            ) {
                if (newDisplayState.EnabledDisplayed === true) {
                    menuText.className = "activeMenulink";
                }
                else {
                    menuText.className = "activeMenulinkDisabled";
                }
            }
        }
        else {
            if (
                (newDisplayState.EnabledDisplayed !== currentDisplayState.EnabledDisplayed)
                || (newDisplayState.ActiveDisplayed === false && (newDisplayState.ActiveDisplayed !== currentDisplayState.ActiveDisplayed))
            ) {
                if (newDisplayState.EnabledDisplayed === true) {
                    menuText.className = "enabledMenulink";
                    menuText.title = "";
                }
                else {
                    menuText.className = "disabledMenulink";
                    menuText.title = navigationRequestInfo.Exception + " " + navigationRequestInfo.ExceptionText;
                }
            }
        }

        if (newDisplayState.MenuTitleDisplayed !== currentDisplayState.MenuTitleDisplayed) {
            menuText.title = newDisplayState.MenuTitleDisplayed;
        }

        if (newDisplayState.EnabledDisplayed === true) {
            rootElement.disabled = false;
            rootElement.setAttribute("aria-disabled", false);
        }
        else {
            rootElement.disabled = true;
            rootElement.setAttribute("aria-disabled", true);
        }
    }

    if (newDisplayState.StatusTitleDisplayed !== currentDisplayState.StatusTitleDisplayed) {
        menuItem = documentObject.getElementById("MenuItem" + activityIdentifier);

        if (statusDisplay === STATUS_DISPLAY_SEPERATE) {
            if (completionImage === null) {
                completionImage = documentObject.getElementById("CompletionStatusImg" + activityIdentifier);
            }
            if (successImage === null) {
                successImage = documentObject.getElementById("SuccessStatusImg" + activityIdentifier);
            }
            completionImage.title = completionTitle;
            successImage.title = successTitle;

            menuItem.setAttribute("aria-label", activity.GetTitle() + " - Completion status: " + completionTitle + ", Success status: " + successTitle);
        }
        else if (statusDisplay === STATUS_DISPLAY_COMBINED || statusDisplay === STATUS_DISPLAY_COMPLETION_ONLY) {
            if (completionImage === null) {
                completionImage = documentObject.getElementById("CompletionStatusImg" + activityIdentifier);
            }
            completionImage.title = statusTitle;

            if (statusDisplay === STATUS_DISPLAY_COMBINED) {
                menuItem.setAttribute("aria-label", activity.GetTitle() + " - Completion+Success status: " + statusTitle);
            }
            else {
                menuItem.setAttribute("aria-label", activity.GetTitle() + " - Completion status: " + statusTitle);
            }
        }
        else if (statusDisplay === STATUS_DISPLAY_SUCCESS_ONLY) {
            if (successImage === null) {
                successImage = documentObject.getElementById("SuccessStatusImg" + activityIdentifier);
            }
            successImage.title = statusTitle;

            menuItem.setAttribute("aria-label", activity.GetTitle() + " - Success status: " + statusTitle);
        }
    }

    return newDisplayState;
}

// determines whether the "show/hide menu" button should be displayed (according to whether or not the course structure is shown)
// called from the window containing the controller
function Integration_SetMenuToggleVisibility (isVisible) {
    var doc = this.GetDocumentObjectForControls(),
        control = doc.getElementById("toggleMenu");

    if (control !== null) {
        if (isVisible === true) {
            control.style.visibility = "visible";
        }
        else {
            control.style.visibility = "hidden";
        }
    }
}

// gets called from both the controller frame and from the frame containing the show/hide button
function Integration_ShowMenu () {
    var translated = this.GetString("Hide Menu");

    // eslint-disable-next-line newline-per-chained-call
    $("#rscp-sidebar").removeClass("sr-only").addClass("col-md-3");
    $("#rscp-main").addClass("col-md-9");

    $("#sidebar-text").html(translated);
    $("#toggleMenu").attr("title", translated);
}

// gets called from both the controller frame and from the frame containing the show/hide button
// needs to be able to handle being called when the frameset is already hidden (happens onload)
function Integration_HideMenu () {
    var translated = this.GetString("Show Menu");

    // eslint-disable-next-line newline-per-chained-call
    $("#rscp-sidebar").removeClass("col-md-3").addClass("sr-only");
    $("#rscp-main").removeClass("col-md-9");

    $("#sidebar-text").html(translated);
    $("#toggleMenu").attr("title", translated);
}

function Integration_ShowExitDialog () {
    // our click event for the returnToLms button will check shouldToggle,
    // and only alow the event to bubble up and trigger the default dropdown toggle behavior if
    // shouldToggle is true
    $("#returnToLms").get(0).shouldToggle = true;

    // controller won't call ShowExitDialog if it's marked visible, but the user might close the dropdown without selecting something
    GetControlWindow().Control.ExitDialogVisible = false;

    $("#exit_dialog_suspend").on(
        "click.rs",
        function (e) {
            e.preventDefault();

            GetControlWindow().Control.ReturnToLms("suspend_all");
        }
    );
    $("#exit_dialog_exit").on(
        "click.rs",
        function (e) {
            e.preventDefault();

            GetControlWindow().Control.ReturnToLms("exit_all");
        }
    );
}

function Integration_HideExitDialog () {
    // handled by dropdown plugin
    $("#exit_dialog_suspend").off("click.rs");
    $("#exit_dialog_exit").off("click.rs");
}

// gets called from the window containing the controller
// eslint-disable-next-line complexity
function Integration_UpdateControlState (doc, aryPossibleRequests, currentActivity) {
    /* globals
       POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE,
       POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS,
       INVALID_MENU_ITEM_ACTION_SHOW_ENABLE,
       INVALID_MENU_ITEM_ACTION_DISABLE,
       INVALID_MENU_ITEM_ACTION_HIDE,
       POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT,
       POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL
    */
    var control = GetControlWindow().Control,
        nextElement = $("#next"),
        prevElement = $("#previous"),
        exitScoElement = $("#closeSco"),
        exitCourseElement = $("#returnToLms"),
        hidePrevious = false,
        hideContinue = false,
        hideExit = false,
        hideAbandon = false, // eslint-disable-line no-unused-vars
        hideSuspendAll = false,
        hideAbandonAll = false,
        hideExitAll = false,
        exceptionText,
        invalidMenuItemAction = control.Package.Properties.InvalidMenuItemAction;

    if (currentActivity !== null) {
        hidePrevious = currentActivity.LearningObject.SequencingData.HidePrevious;
        hideContinue = currentActivity.LearningObject.SequencingData.HideContinue;
        hideExit = currentActivity.LearningObject.SequencingData.HideExit;
        hideAbandon = currentActivity.LearningObject.SequencingData.HideAbandon;
        hideSuspendAll = currentActivity.LearningObject.SequencingData.HideSuspendAll;
        hideAbandonAll = currentActivity.LearningObject.SequencingData.HideAbandonAll;
        hideExitAll = currentActivity.LearningObject.SequencingData.HideExitAll;
    }

    if (nextElement.length !== 0) {
        nextElement.attr("title", this.GetString("Next"));
        if (
            (aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE].WillSucceed === true && hideContinue === false)
            || (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_SHOW_ENABLE)
        ) {
            nextElement.removeClass("disabledTopMenuItem");
            nextElement.addClass("enabledTopMenuItem");
            nextElement.prop("disabled", false);
            nextElement.on(
                "click",
                function () {
                    GetControlWindow().Control.Next();

                    return true;
                }
            );
        }
        else {
            if (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_DISABLE) {
                nextElement.removeClass("enabledTopMenuItem");
                nextElement.addClass("disabledTopMenuItem");
                nextElement.prop("disabled", true);
                nextElement.off("click");
                if (hideContinue) {
                    nextElement.attr("title", this.GetString("You cannot use 'Next' with this item."));
                }
                else {
                    exceptionText = aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_CONTINUE].GetErrorString();
                    // eslint-disable-next-line max-depth
                    if (exceptionText) {
                        nextElement.attr("title", exceptionText);
                    }
                }
            }
            else if (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_HIDE) {
                nextElement.removeClass("disabledTopMenuItem enabledTopMenuItem");
            }
        }
    }

    if (prevElement.length !== 0) {
        prevElement.attr("title", this.GetString("Previous"));
        if (
            (aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS].WillSucceed === true && hidePrevious === false)
            || (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_SHOW_ENABLE)
        ) {
            prevElement.removeClass("disabledTopMenuItem");
            prevElement.addClass("enabledTopMenuItem");
            prevElement.prop("disabled", false);
            prevElement.on(
                "click",
                function () {
                    GetControlWindow().Control.Previous();

                    return true;
                }
            );
        }
        else {
            if (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_DISABLE) {
                prevElement.removeClass("enabledTopMenuItem");
                prevElement.addClass("disabledTopMenuItem");
                prevElement.prop("disabled", true);
                prevElement.off("click");
                if (hidePrevious) {
                    prevElement.attr("title", this.GetString("This lesson does not allow 'Previous' requests."));
                }
                else {
                    exceptionText = aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_PREVIOUS].GetErrorString();
                    if (exceptionText) {
                        prevElement.attr("title", exceptionText);
                    }
                }
            }
            else if (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_HIDE) {
                prevElement.removeClass("disabledTopMenuItem enabledTopMenuItem");
            }
        }
    }

    if (exitScoElement.length !== 0) {
        exitScoElement.attr("title", this.GetString("Close Item"));
        if (
            (aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT].WillSucceed === true && hideExit === false)
            || (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_SHOW_ENABLE)
        ) {
            exitScoElement.removeClass("disabledTopMenuItem");
            exitScoElement.addClass("enabledTopMenuItem");
            exitScoElement.prop("disabled", false);
            exitScoElement.on(
                "click",
                function () {
                    GetControlWindow().Control.CloseSco();

                    return true;
                }
            );
        }
        else {
            if (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_DISABLE) {
                exitScoElement.removeClass("enabledTopMenuItem");
                exitScoElement.addClass("disabledTopMenuItem");
                exitScoElement.prop("disabled", true);
                exitScoElement.off("click");
                if (hideExit) {
                    exitScoElement.attr("title", this.GetString("You cannot use 'Exit' with this item."));
                }
                else {
                    exceptionText = aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT].GetErrorString();
                    if (exceptionText) {
                        exitScoElement.attr("title", exceptionText);
                    }
                }
            }
            else if (invalidMenuItemAction === INVALID_MENU_ITEM_ACTION_HIDE) {
                exitScoElement.removeClass("disabledTopMenuItem enabledTopMenuItem");
            }
        }
    }

    // We only want to disable the Exit button if it is is explicitly hidden by sequencing rules,
    // otherwise, always enable it (regardless of what the look ahead sequencer says)
    if (exitCourseElement !== null) {
        exitCourseElement.off("click.rs.TriggerReturnToLMS keydown.rs.TriggerReturnToLMS");
        exitCourseElement.attr("title", this.GetString("Return to LMS"));

        if (hideExitAll === true && hideSuspendAll === true && hideAbandonAll === true) {
            exitCourseElement.removeClass("enabledTopMenuItem");
            exitCourseElement.addClass("disabledTopMenuItem");
            exitCourseElement.prop("disabled", true);
            exceptionText = aryPossibleRequests[POSSIBLE_NAVIGATION_REQUEST_INDEX_EXIT_ALL].GetErrorString();
            if (exceptionText) {
                exitCourseElement.attr("title", exceptionText);
            }
        }
        else {
            exitCourseElement.removeClass("disabledTopMenuItem");
            exitCourseElement.addClass("enabledTopMenuItem");
            exitCourseElement.prop("disabled", false);

            if (control.Package.LearningStandard.is2004() && control.Package.Properties.ReturnToLmsAction === "selectable") {
                exitCourseElement.attr("aria-haspopup", "true");
                exitCourseElement.attr("aria-expanded", "false");
                exitCourseElement.attr("aria-controls", "returnToLmsMenu");
            }

            exitCourseElement.off("click.rs.TriggerReturnToLMS keydown.rs.TriggerReturnToLMS");
            exitCourseElement.on(
                "click.rs.TriggerReturnToLMS keydown.rs.TriggerReturnToLMS",
                _exitElementHandler
            );
        }
    }
}

function Integration_UpdateProgressBar (doc, currentActivity) {
    var topParams = rscpCfg.get("topParams"),
        control = GetControlWindow().Control,
        progressText = $("#progressText"),
        progressImage = $("#progressImage"),
        intProgressPercent,
        label = "",
        valueNow,
        valueMax,
        activityList,
        numComplete,
        i,
        rootActivity;

    if (typeof topParams.useMeasureProgress === "undefined" || ! topParams.useMeasureProgress) {
        if (this.NumDeliverableScos === null) {
            this.NumDeliverableScos = control.Activities.GetNumDeliverableActivities();
        }

        // find the number of complete and not failed activities
        activityList = control.Activities.ActivityList;
        numComplete = 0;
        for (i = 0; i < activityList.length; i += 1) {
            if (activityList[i].IsDeliverable() && activityList[i].IsCompleted() === true && activityList[i].IsSatisfied() !== false) {
                numComplete += 1;
            }
        }

        label = numComplete + " / " + this.NumDeliverableScos;
        valueNow = numComplete;
        valueMax = this.NumDeliverableScos;
        intProgressPercent = parseInt((numComplete / this.NumDeliverableScos) * 100, 10);
    }
    else {
        rootActivity = currentActivity;
        if (rootActivity !== null) {
            while (rootActivity.IsTheRoot() !== true) {
                rootActivity = rootActivity.ParentActivity;
            }

            intProgressPercent = parseInt(rootActivity.GetAttemptCompletionAmount() * 100, 10);
        }
        else {
            intProgressPercent = 0;
        }

        label = intProgressPercent + "%";
        valueNow = intProgressPercent;
        valueMax = "100";
    }

    progressImage.css("width", intProgressPercent + "%");
    progressImage.attr("aria-valuenow", valueNow);
    progressImage.attr("aria-valuemax", valueMax);
    progressText.html(label);
}

function Integration_PreOverallSequencingProcess () {
    // Default implementation does nothing here
}

function Integration_PostScoLoaded (activity) {
    var frameElement = document.getElementById(this.CONTENT_FRAME_NAME);

    frameElement.setAttribute("title", activity.GetTitle());
    frameElement.contentWindow.focus();
}

function Integration_PostScoUnloaded () {
    var frameElement = document.getElementById(this.CONTENT_FRAME_NAME),
        firstNavMenuElement = document.getElementsByClassName("menuitem")[0],
        menuToggle = document.getElementById("toggleMenu"),
        title;

    if (menuToggle !== null && menuToggle.style.visibility === "visible") {
        title = this.GetString("Please make a selection from the Course Menu.");
    }
    else {
        title = this.GetString("Please make a selection from the Navigation Controls.");
    }

    frameElement.setAttribute("title", title);
    firstNavMenuElement.focus();
}

// The DOM can be manipulated here to add custom modifications to the menu
// This method will be called whenever the menu is modified by the existing SW
// Code here must be robust enough to handle being called multiple times.
// eslint-disable-next-line no-empty-function
function Integration_OverrideMenuLookAndFeel () {
}

// eslint-disable-next-line newline-per-chained-call
if (window.location.toString().toLowerCase().indexOf("preventrightclick=true") > 0) {
    window.document.oncontextmenu = function () {
        return false;
    };
}

window.IntegrationImplementation = new Integration();

(function () {
    var isMobile = false,
        userAgent = navigator.userAgent,
        agentNames = [
            "android",
            "ipod",
            "iphone",
            "ipad",
            "iemobile",
            "silk"
        ],
        i;

    for (i = 0; i < agentNames.length; i += 1) {
        if (userAgent.indexOf(agentNames[i]) !== -1) {
            isMobile = true;
            break;
        }
    }

    // will return a reference to the BODY tag of the frame content
    // or null if the frame is cross-domain or BODY is otherwise
    // unavailable to us
    function GetFrameBodyElement (frame) {
        try {
            // this line will fail if cross domain, or no body tag
            return frame.contentWindow.document.getElementsByTagName("body")[0];
        }
        catch (e) {
            return null;
        }
    }

    // sets up our attempt to scale non-responsive content on mobile
    if (isMobile) {
        // wrapping iframe so that we can get rid of extra blank space caused by iframe before shrinking
        $("#ContentDiv iframe").wrap("<div id=\"ModernPlayerScalingWrapper\" style=\"height: 100%; overflow: visible; margin: 0; padding: 0;\"></div>");

        // once iframe loads run through and check for whether we need to scale
        $("#ContentDiv iframe").on(
            "load",
            function () {
                var $iframe = $(this),
                    $iframeWrapper = $("#ModernPlayerScalingWrapper"),
                    // div that contains all this; has to fit within its width
                    $contentDiv = $("#ContentDiv"),
                    $iframeDoc = $(this.contentWindow.document),
                    $contentFrames = $iframeDoc.find("frame"),
                    $contentBody = $iframeDoc.find("body");

                // need to hook into load of all content frames to check them for scrolling content
                $contentFrames.on(
                    "load.modernPlayer",
                    function () {
                        // mark whether the iframe is scalable (not cross-domain or containing flash content)
                        $(this).toggleClass("rs-mp-canscale", GetFrameBodyElement(this) !== null);

                        // scale iframe to updated size
                        setScaling();
                    }
                );

                // re-scale when window resizes (or orientation change on mobile)
                $(window).on(
                    "resize.modernPlayer",
                    function () {
                        setScaling();
                    }
                );

                // intial load for body only
                setScaling();

                // Private functions ---
                function setScaling () {
                    var contentDivWidth = $contentDiv.width(),
                        largestWidth = contentDivWidth || 0,
                        totalHeight = 0,
                        scaleFactor = 1;

                    // skipping if we haven't actually set this for scaling yet
                    if ($iframe.hasClass("rs-mp-scaled")) {
                        // set iframe width/scaling back to normal so we can get
                        // correct numbers for scaling
                        $iframeWrapper.css(
                            {
                                height: "100%",
                                overflow: "visible"
                            }
                        );

                        $iframe.css(
                            {
                                "-ms-transform": "",
                                "-moz-transform": "",
                                "-o-transform": "",
                                "-webkit-transform": "",
                                transform: "",
                                width: "100%",
                                height: "100%"
                            }
                        ).removeClass("rs-mp-scaled");
                    }

                    //
                    // go through all frames/body to look if any content is wider than viewport
                    //

                    // check body of the iframe (if not using frameset, this will be relevant)
                    if ($contentBody.length) {
                        largestWidth = Math.max(largestWidth, $contentBody[0].scrollWidth || 0);
                        totalHeight = $contentBody[0].scrollHeight || 0;
                    }
                    else {
                        // check for any frame content that's larger
                        $contentFrames.filter(".rs-mp-canscale").each(
                            function () {
                                var body = GetFrameBodyElement(this),
                                    width = body.scrollWidth || 0,
                                    height = body.scrollHeight || 0;

                                // TODO: This only really works if this is a
                                // frameset with a single column; would need more work to
                                // examine ROWS/COLS attributes of the FRAMESET to add widths
                                // together for other situations
                                largestWidth = Math.max(largestWidth, width);
                                totalHeight += height;
                            }
                        );
                    }

                    // in case we're not able to get accurate height of content, or it's
                    // shorter than the height we already have . . .
                    totalHeight = Math.max(totalHeight, $contentDiv.height() || 0);

                    // amount to scale is based on the width only
                    scaleFactor = contentDivWidth / largestWidth;

                    // only scaling if we need to shrink content
                    if (scaleFactor < 1) {
                        // resize container div to match shrunk iframe, so no unnecessary scrollbars
                        // causes by whitespace left in place where iframe used to be before
                        // scaling (scale doesn't reflow the document)
                        $iframeWrapper.css(
                            {
                                height: (totalHeight * scaleFactor) + 40 + "px",
                                overflow: "hidden"
                            }
                        );

                        // have to set width/height on iframe to the content width/height before
                        // scaling or you just end up with a small iframe with tiny scrollbars . . .
                        $iframe.css(
                            {
                                width: largestWidth + "px",
                                height: totalHeight + "px",
                                "-ms-transform": "scale(" + scaleFactor + ")",
                                "-ms-transform-origin": "0 0",
                                "-moz-transform": "scale(" + scaleFactor + ")",
                                "-moz-transform-origin": "0 0",
                                "-o-transform": "scale(" + scaleFactor + ")",
                                "-o-transform-origin": "0 0",
                                "-webkit-transform": "scale(" + scaleFactor + ")",
                                "-webkit-transform-origin": "0 0",
                                transform: "scale(" + scaleFactor + ")",
                                "transform-origin": "0 0"
                            }
                        ).addClass("rs-mp-scaled");
                    }
                }
            }
        );
    }
}());
